import { useState } from "react";

export default function PressAdminGate({ onUnlock }) {
  const [pwInput, setPwInput] = useState("");
  const [pwError, setPwError] = useState("");

  const login = async (e) => {
    e.preventDefault();
    setPwError("");
    const t = pwInput.trim();
    if (!t) return;
    // Verify by pinging the zip endpoint (cheap + admin-gated)
    try {
      const r = await fetch("/api/press/kit.zip", { method: "HEAD", headers: { "X-Admin-Token": t } });
      if (r.status === 401 || r.status === 403) {
        setPwError("That token didn't work. Try again.");
        return;
      }
      try { window.localStorage.setItem("sws_admin_token", t); } catch { /* ignore */ }
      onUnlock(t);
    } catch (err) {
      console.warn("Press: admin verify failed:", err);
      setPwError("Couldn't verify — try again.");
    }
  };

  return (
    <section className="px-4 md:px-8 py-24 md:py-32 max-w-md mx-auto text-center" data-testid="press-admin-gate">
      <p className="text-[#B32027] uppercase tracking-[0.4em] text-xs font-bold mb-4">/ Admin only</p>
      <h1 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl md:text-5xl mb-4">Press &amp;<br /><span className="text-[#B32027]">Ambassador Kit</span></h1>
      <p className="text-white/70 text-sm leading-relaxed mb-8">
        This page is restricted. Enter your admin token to access the full launch kit.
      </p>
      <form onSubmit={login} className="space-y-3">
        <input
          type="password"
          value={pwInput}
          onChange={(e) => setPwInput(e.target.value)}
          placeholder="Admin token"
          autoFocus
          data-testid="press-admin-input"
          className="w-full bg-[#0F0F0F] border-2 border-white/15 focus:border-[#B32027] outline-none text-white px-4 py-4 text-sm tracking-wide"
        />
        <button
          type="submit"
          data-testid="press-admin-submit"
          className="w-full bg-[#B32027] hover:bg-[#D42730] text-white px-6 py-4 text-[11px] font-bold uppercase tracking-[0.3em] transition-colors"
        >
          Unlock the kit
        </button>
        {pwError && <p className="text-red-400 text-xs mt-2">{pwError}</p>}
      </form>
      <p className="text-white/40 text-xs mt-6 uppercase tracking-[0.25em] font-bold">
        Need the kit? Email Admin@sweatwithslay.com
      </p>
    </section>
  );
}
